import script from "./OnboardingLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingLayout.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingLayout.vue?vue&type=style&index=0&id=58fe743e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58fe743e"]])

export default __exports__